import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  Heading,
  Body,
} from '../../coreui';

import DynamicBrowseJoinLink from '../../helpers';
import CalloutFrame from '../../components/CalloutFrame';

import ImageBg from '../../assets/img_panel_homepage_approval.png';

const RightOpportunities = ({ isLoggedIn }) => {
  return (
    <CalloutFrame
      bg="black"
      image={ImageBg}
      imageType="image"
      imageProps={{
        mt: [0, 80, 100, 120, 140],
        mb: [60, 80, 100, 120, 140],
      }}
    >
      <Heading
        type="H2"
        mt={0}
        color="white"
      >
        Only the right opportunities
      </Heading>
      <Body
        type="B1"
        mb={0}
        color="white"
      >
        On average, for every 1,000 deals we scrutinize, only
        one may meet all the criteria of our rigorous underwriting process.
      </Body>
      <ExtendedFlex
        mt="auto"
        pt={20}
        mb={[null, null, 50]}
      >
        <DynamicBrowseJoinLink
          isLoggedIn={isLoggedIn}
          anonText="Get Started"
          type="L1"
        />
      </ExtendedFlex>
    </CalloutFrame>
  );
};

RightOpportunities.propTypes = {
  isLoggedIn: PropTypes.bool,
};

export default RightOpportunities;
